import { render } from "./PedidosPrevisionComisiones.vue?vue&type=template&id=551a3f6a&scoped=true"
import script from "./PedidosPrevisionComisiones.vue?vue&type=script&lang=ts"
export * from "./PedidosPrevisionComisiones.vue?vue&type=script&lang=ts"

import "./PedidosPrevisionComisiones.vue?vue&type=style&index=0&id=551a3f6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-551a3f6a"

export default script